export default __webpack_public_path__ + "6e7e53ff5ae2e2ab379747a70811369d.webp";